<template>
    <div class="row">
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-top">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel" data-v-step-routing-form-step-3="1">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" :disabled="loading" @click="previousStep" data-v-step-routing-form-step-3="2">
                            <i class="fa fa-fw fa-caret-left"></i> VOLTAR
                        </button>
                        <button class="button-edit" style="float: right;" :disabled="loading" @click="nextStep" data-v-step-routing-form-step-3="3">
                            PRÓXIMA <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-caret-right')"></i>
                        </button>
                        <button class="btn button-edit button-cancel btn-right" @click="$refs.tour.editTour()">
                            <i class="fas fa-question-circle"></i> TOUR
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-heading">
                <div class="row">
                    <div class="col-xs-12 col-lg-4 heading-page">
                        <small><b>Selecione as entregas</b> <span v-popover:tooltip.right="'Selecione as entregas que participarão do roteiro, a lista está inicialmente filtrada pela data de entrega, a partir da data atual'"><i class="fas fa-question-circle"></i></span></small>
                    </div>
                    <div class="col-xs-12 col-lg-8">
                        <button v-if="client_atak" class="btn-delivery" @click="show_modal_synchronization_atak = true" :data-v-step-routing-form-step-3="client_atak ? '7' : ''">
                            <i class="fa fa-sync"></i> SINCRONIZAR
                        </button>
                        <button class="btn-delivery" @click="select_files" data-v-step-routing-form-step-3="6">
                            <i class="fa fa-upload"></i> IMPORTAR
                        </button>
                        <button class="btn-delivery" @click="newDelivery" data-v-step-routing-form-step-3="5">
                            <i class="fa fa-plus"></i> ADICIONAR
                        </button>
                        <button class="btn-delivery" @click="show_modal_map = true" data-v-step-routing-form-step-3="4">
                            <i class="fa fa-map-marker-alt"></i> VISUALIZAR NO MAPA
                        </button>
                    </div>
                </div>
            </div>
            <div class="container-filter" :data-v-step-routing-form-step-3="client_atak ? '8' : '7'">
                <div class="row">
                    <div class="col-xs-12 col-lg-12 collapse-header" @click="show_filters = !show_filters">
                        <div class="container-collapse-header">
                            <span><b><i class="fa fa-fw fa-sliders-h"></i> Filtros</b></span>
                            <span class="collapse-header-arrow" v-if="show_filters"><i class="fa fa-chevron-up"></i></span>
                            <span class="collapse-header-arrow" v-else><i class="fa fa-chevron-down"></i></span>
                        </div>
                    </div>
                    <div v-show="show_filters" class="col-xs-12 col-lg-12 container-collapse-body">
                        <div class="collapse-body">
                            <div class="row">
                                <div class="col-xs-12 col-lg-3">
                                    <FormInput v-model="filters.start" label="Data de entrega inicial" type="date" :required="true" ref="start_filter" tooltip="Informe a data de entrega inicial desejada" />
                                </div>   
                                <div class="col-xs-12 col-lg-3">
                                    <FormInput v-model="filters.end" label="Data de entrega final" type="date" :required="true" ref="end_filter" tooltip="Informe data de entrega final desejada" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelect v-model="filters.type" label="Tipo" :options="options_default.type" :multiple="true" :required="false" ref="type_filter" tooltip="Selecione o tipo da entrega desejada" />
                                </div>
                            </div>
                            <div v-if="filters.show_complete_inputs" class="row">
                                <div class="col-xs-12 col-lg-4">
                                    <FormSelect v-model="filters.company_document" label="Emissor" :options="options.documents" :multiple="true" :required="false" ref="company_document_filter" tooltip="Selecione o emissor das entregas" />
                                </div>
                                <div class="col-xs-12 col-lg-4">
                                    <FormSelect v-model="filters.customer" label="Cliente" :options="options.customers" :multiple="true" :required="false" ref="customer_filter" tooltip="Selecione o cliente desejado" />
                                </div>
                                <div v-if="client_atak && (Object.keys(options.dcs).length > 0)" class="col-xs-12 col-lg-4">
                                    <FormSelect v-model="filters.dc" label="Centro de Distribuição" :options="options.dcs" :multiple="true" :required="false" ref="dc_filter" tooltip="Selecione o local de estoque desejado" />
                                </div>
                                <div class="col-xs-12 col-lg-2">
                                    <FormInput v-model="filters.document_number" label="Número" type="text" :required="false" ref="document_number_filter" tooltip="Informe o número da entrega desejada" />
                                </div>
                                <div class="col-xs-12 col-lg-2">
                                    <FormInputMasked v-model="filters.postal_code" label="CEP" type="text" :required="false" mask="#####-###" ref="address_postal_code_filter" tooltip="Informe o CEP desejado" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormInput v-model="filters.street" label="Logradouro" type="text" :required="false" ref="address_street_filter" tooltip="Informe o logradouro desejado" />
                                </div>
                                <div class="col-xs-12 col-lg-2">
                                    <FormInput v-model="filters.neighborhood" label="Bairro" type="text" :required="false" ref="address_neighborhood_filter" tooltip="Informe o bairro desejado" />
                                </div>
                                <div class="col-xs-12 col-lg-3">
                                    <FormSelect v-model="filters.city" label="Cidade" :options="options.cities" :multiple="true" :required="false" :loading="loading" ref="address_city_filter" tooltip="Informe a cidade desejada" />
                                </div>
                                <div class="col-xs-12 col-lg-2">
                                    <FormSelect v-model="filters.uf" label="UF" :options="options.ufs" :multiple="true" :required="false" ref="address_uf_filter" tooltip="Selecione a UF desejada" />
                                </div>
                                <div v-if="Object.keys(options.zones).length > 0" class="col-xs-12 col-lg-4">
                                    <FormSelect v-model="filters.zone" label="Zona" :options="options.zones" :multiple="true" :required="false" ref="address_zone_filter" tooltip="Selecione a zona da cidade desejada" />
                                </div>
                                <div v-if="client_atak && (Object.keys(options.courses).length > 0)" class="col-xs-12 col-lg-4">
                                    <FormSelect v-model="filters.course" label="Percurso" :options="options.courses" :multiple="true" :required="false" ref="address_course_filter" tooltip="Selecione o percurso desejado" />
                                </div>
                                <div v-if="client_atak" class="col-xs-12 col-lg-3">
                                    <FormSelect v-model="filters.temperature" label="Temperatura" :options="options_default.temperature" :multiple="true" :required="false" ref="temperature_filter"  tooltip="Selecione a temperatura desejada" />
                                </div>
                                <div v-if="client_atak" class="col-xs-12 col-lg-3">
                                    <FormSelect v-model="filters.bone" label="Osso" :options="options_default.bone" :multiple="true" :required="false" ref="bone_filter" tooltip="Selecione a característica desejada" />
                                </div>
                                <div class="col-xs-12 col-lg-2">
                                    <FormCheckbox v-model="filters.no_weight_zero" label="Desconsiderar peso zerado" ref="no_weight_zero_filter" tooltip="Informe a filtragem de peso desejada" />
                                </div>
                            </div>
                            <div v-if="!filters.show_complete_inputs && loading_filters" class="row" style="text-align: center;">
                                <div class="col-xs-12 col-lg-12">
                                    <i class="fas fa-circle-notch fa-spin"></i> Carregando...
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-lg-2">
                                    <button class="add_new_filters" @click="filter_deliveries()">
                                        <i class="fas fa-filter"></i> Filtrar
                                    </button>
                                </div>
                                <div class="col-xs-12 col-lg-2">
                                    <button class="add_new_filters" @click="clean_filters()">
                                        <i class="fas fa-eraser"></i> Limpar
                                    </button>
                                </div>
                            </div>                     
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12 config-tab-container">
            <br/>
            <button class="config-tab" :class="{ 'enabled': (tab == 'list') }" @click="tab = 'list'" :data-v-step-routing-form-step-3="client_atak ? '9' : '8'">
                Lista ({{ list.length }})
            </button>
            <button class="config-tab" :class="{ 'enabled': (tab == 'selected') }" @click="tab = 'selected'" :data-v-step-routing-form-step-3="client_atak ? '10' : '9'">
                Selecionados ({{ selected.length }})
            </button>
        </div>
        <div class="col-xs-12 col-lg-12 config-tab-block" :class="{ 'show': (tab == 'list') }">
            <RoutingTable 
                :loading="loading" 
                :headers="headers" 
                :ordering="ordering" 
                :order="order" 
                :list="list" 
                :page="page" 
                :per_page="per_page" 
                :total="total" 
                :label="'entregas'"
                :modifiers="modifiers" 
                :select_all="select_all" 
                :on_select="on_select" 
                :selected="selected_list" 
                :is_selected="false"
                :selected_weight_capacity="selected_weight_capacity"
                :selected_weight="total_weight"
                @reorder="(o) => {
                    order = o;
                    load();
                }"
                :data-v-step-routing-form-step-3="client_atak ? '11' : '10'"
            />
        </div>
        <div class="col-xs-12 col-lg-12 config-tab-block" :class="{ 'show': (tab == 'selected') }">
            <RoutingTable 
                :loading="loading" 
                :headers="headers" 
                :ordering="ordering" 
                :order="order_selected" 
                :list="selected_list" 
                :page="page" 
                :per_page="per_page" 
                :total="total" 
                :label="'entregas'"
                :modifiers="modifiers" 
                :select_all="selected_select_all" 
                :on_select="on_select" 
                :selected="selected_list" 
                :is_selected="true"
                :selected_weight_capacity="selected_weight_capacity"
                :selected_weight="total_weight"
                @reorder="(o) => {
                    order_selected = o;
                    reorder();
                }"
            />
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-bottom">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" :disabled="loading" @click="previousStep">
                            <i class="fa fa-fw fa-caret-left"></i> VOLTAR
                        </button>
                        <button class="button-edit" style="float: right;" :disabled="loading" @click="nextStep">
                            PRÓXIMA <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-caret-right')"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <RoutingModalMap v-if="show_modal_map"
            :name="$parent.data[1].name"
            :date="$parent.data[1].date"
            :distribution_center="$parent.data[1].distribution_center"
            :list="list"
            :selected="selected_list"
            :total_weight="total_weight"
            :client_atak="client_atak"
            :default_moviment_type_code="default_moviment_type_code"
            @select="on_select"
        />
        <DeliveryForm v-if="show_modal_form"
            :current="current_form"
            :my_customers="my_customers"
			:my_documents="my_documents"
			:my_drivers="my_drivers"
        />
        <DeliverySynchronizationAtak v-if="show_modal_synchronization_atak"
            :url_api_atak="url_api_atak"
            :default_customer_sync_name="default_customer_sync_name"
            :default_moviment_type_code="default_moviment_type_code"
        />
        <DeliveryImport v-if="show_modal_import"
            :files="uploading"
            @update="updateFiles"
        />

        <input ref="upload_input" type="file" multiple="multiple" accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/plain, text/xml" style="display: none;" @change="upload_files" />

        <Tour
            tour="DeliveryRouting"
            :steps="tour_steps"
			ref="tour"
        />
    </div>
</template>

<script>
import Api from "@/lib/Api";

import FormCheckbox from "@/components/FormCheckbox.vue";
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";
import Tour from "@/components/Tour";
import DeliveryForm from "../Delivery/DeliveryForm";
import DeliveryImport from "../Delivery/DeliveryImport";
import DeliverySynchronizationAtak from "../Delivery/DeliverySynchronizationAtak";
import RoutingModalMap from "../Routing/RoutingModalMap";
import RoutingTable from "../Routing/RoutingTable";

export default {
    name: "RoutingFormStep3",
    
    props: {
        data: {
            type: Array,
            require: true,
        },
        my_customers: {
			type: Array,
			required: true,
		},
		my_drivers: {
			type: Array,
			required: true,
		},
		my_documents: {
			type: Array,
			required: true,
		},
        selected: {
            type: Array,
            require: true,
        },
        filter_fields: {
            type: Object,
            require: true,
        },
        filter_options: {
            type: Object,
            require: true,
        },
        selected_weight_capacity: {
            type: Number,
            require: true,
            default: 0.0,
        },
        url_api_atak: {
            type: String,
            require: false,
            default: "",
        },
        default_customer_sync_name: {
            type: String,
            require: false,
            default: "",
        },
        default_moviment_type_code: {
            type: String,
            require: false,
            default: "",
        },
    },
    
    components: {
        FormCheckbox,
        FormInput,
        FormInputMasked,
        FormSelect,
        Tour,
        DeliveryForm,
        DeliveryImport,
        DeliverySynchronizationAtak,
        RoutingModalMap,
        RoutingTable,
    },

    data: function() {
        let steps = [
            {
                target: '[data-v-step-routing-form-step-3="0"]',
                header: {
                    title: '<code>PASSO ATUAL</code>',
                },
                content: '<code>Verifique aqui o passo atual</code>',
                params: {
                    placement: 'bottom',
                    highlight: true,
                }
            },
            {
                target: '[data-v-step-routing-form-step-3="1"]',
                header: {
                    title: '<code>CANCELAR</code>',
                },
                content: '<code>Clique em <b>CANCELAR</b> para interromper o processo e voltar para lista de roteiros</code>',
                params: {
                    placement: 'right',
                    highlight: true,
                }
            },
            {
                target: '[data-v-step-routing-form-step-3="2"]',
                header: {
                    title: '<code>VOLTAR</code>',
                },
                content: '<code>Clique em <b>VOLTAR</b> para voltar para a etapa anterior</code>',
                params: {
                    placement: 'right',
                    highlight: true,
                }
            },
            {
                target: '[data-v-step-routing-form-step-3="3"]',
                header: {
                    title: '<code>CONTINUAR</code>',
                },
                content: '<code>Clique em <b>PRÓXIMA</b> para avançar para a etapa seguinte</code>',
                params: {
                    placement: 'left',
                    highlight: true,
                }
            },
            {
                target: '[data-v-step-routing-form-step-3="4"]',
                header: {
                    title: '<code>MAPA</code>',
                },
                content: '<code>Clique em <b>VISUALIZAR NO MAPA</b> para ver no mapa as localizações das entregas</code>',
                params: {
                    placement: 'left',
                    highlight: true,
                }
            },
            {
                target: '[data-v-step-routing-form-step-3="5"]',
                header: {
                    title: '<code>ADICIONAR</code>',
                },
                content: '<code>Clique em <b>ADICIONAR</b> para abrir o formulário de cadastro manual de uma nova entrega</code>',
                params: {
                    placement: 'left',
                    highlight: true,
                }
            },
            {
                target: '[data-v-step-routing-form-step-3="6"]',
                header: {
                    title: '<code>IMPORTAR</code>',
                },
                content: '<code>Clique em <b>IMPORTAR</b> para abrir o formulário de importação entrega a partir de arquivos (.csv, .txt, .xls, .xlsx ou .xml)</code>',
                params: {
                    placement: 'left',
                    highlight: true,
                }
            },
        ];

        if (this.$api.user.company_client_atak) {
            steps = steps.concat([
                {
                    target: '[data-v-step-routing-form-step-3="7"]',
                    header: {
                        title: '<code>SINCRONIZAR</code>',
                    },
                    content: '<code>Clique em <b>SINCRONIZAR</b> para abrir o formulário de sincronização de pedidos com o sistema integrado</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-3="8"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campos de filtragem dos registros</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-3="9"]',
                    header: {
                        title: '<code>LISTAGEM ATUAL</code>',
                    },
                    content: '<code>Aba de exibição dos registros, clique em <b>LISTA</b> para mostrar a lista de registros atuais</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-3="10"]',
                    header: {
                        title: '<code>LISTAGEM DE SELEÇÃO</code>',
                    },
                    content: '<code>Aba de exibição dos registros, clique em <b>SELECIONADOS</b> para mostrar a lista de registros selecionados</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-3="11"]',
                    header: {
                        title: '<code>ENTREGAS</code>',
                    },
                    content: '<code>Lista dos registros de entregas cadastradas</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
        } else {
            steps = steps.concat([
                {
                    target: '[data-v-step-routing-form-step-3="7"]',
                    header: {
                        title: '<code>FILTRAGEM</code>',
                    },
                    content: '<code>Campos de filtragem dos registros</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-3="8"]',
                    header: {
                        title: '<code>LISTAGEM ATUAL</code>',
                    },
                    content: '<code>Aba de exibição dos registros, clique em <b>LISTA</b> para mostrar a lista de registros atuais</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-3="9"]',
                    header: {
                        title: '<code>LISTAGEM DE SELEÇÃO</code>',
                    },
                    content: '<code>Aba de exibição dos registros, clique em <b>SELECIONADOS</b> para mostrar a lista de registros selecionados</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-3="10"]',
                    header: {
                        title: '<code>ENTREGAS</code>',
                    },
                    content: '<code>Lista dos registros de entregas cadastradas</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ]);
        }
           
        return {
            loading: false,
            loading_filters: false,
            filters: this.filter_fields,

            tab: 'list',

			headers: {
				document_number: "Número",
				code_course: "Percurso",
				type: "Tipo",
                date: "Data entrega",
                company_name: "Emissor",
                customer_name: "Cliente",
				street: "Endereço",
				quantity: "Itens",
				weight: "Peso"
			},
            ordering: ['document_number', 'code_course', 'date', 'company_name', 'customer_name', 'weight'],
            order: "code_course-ASC",
            order_selected: "code_course-ASC",
            list: [],
            page: 0,
            per_page: 0,
            total: 0,
            modifiers: {
                code_course: function(d, item) {
                    let str = "";
                    let color = "";

                    if (d) { 
                        str = d + " - " + item.course;
                    } else {
                        str = "Não Definido";
                        color = "color: #aaa";
                    }

                    return `<span class="capitalized" title="${str}" style="${color}">${str}</span>`;
                },
                type: function(d) {
                    if (d == 0) {
                        return "<span title='Nota Fiscal'>Nota F.</span>";
                    } else {
                        return "<span title='Pedido'>Pedido</span>";
                    }
				},

                date: function(d) {
                    let date = d.split("-").reverse().join("/");
                    return "<span title='" + date + "'>" + date + "</span>";
                },

                company_name: function(d) {
                    if (d.length > 25) {
						return `<span class="capitalized" title="${d}">${d.toLowerCase().slice(0, 25)}...</span>`;
					} else {
						return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
					}
                },
                
                customer_name: function(d) {
                    if (d.length > 25) {
						return `<span class="capitalized" title="${d}">${d.toLowerCase().slice(0, 25)}...</span>`;
					} else {
						return `<span class="capitalized" title="${d}">${d.toLowerCase()}</span>`;
					}
                },

                street: function(d, item) {
                    if(item.street != null) {
                        let address = item.street.toLowerCase() + ", " + item.number.toLowerCase() + " - " + item.neighborhood.toLowerCase() + ", " + item.city.toLowerCase() + " - " + item.uf + ", " + item.postal_code;
                        
                        return "<span class='capitalized' title='" + address + "'>" + address + "</span>";
                    } else {
                        return "";
                    }
                },

                weight: function(d) {
                    let weight_formatted = "";
                    if(d < 1000) weight_formatted = d.toFixed(2) + " kg";
                    else weight_formatted = (d / 1000).toFixed(2) + " t";
                    return "<span title='" + weight_formatted.replace(".", ",") + "'>" + weight_formatted.replace(".", ",") + "</span>";
                }
            },
            selected_list: this.selected,
            
            point_list: this.data,
            //cities_list: [],
            
            show_modal_map: false,
            show_modal_form: false,
            show_modal_synchronization_atak: false,
            show_modal_import: false,
            show_filters: true,

            current_form: false,

            start_aux: "",
            end_aux: "",
            
			uploading: [],
            
			results: [],
			formats: [
				".csv",
				"application/vnd.ms-excel",
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
				"text/plain", 
				"text/xml"
			],
            options: this.filter_options,
            options_default: {
				type: {
					"0": "NOTA FISCAL",
					"1": "PEDIDO",
				},
                temperature: {
                    "0": "AMBIENTE",
                    "2": "CONGELADO",
                    "1": "RESFRIADO",
                },
                bone: {
                    "0": "COM OSSO",
                    "1": "SEM OSSO",
                }
            },
			
			client_atak: this.$api.user.company_client_atak,
            all_selected: true,
            total_weight: 0.00,
            
            tour_steps: steps,
        }
    },

    mounted: async function() {
        this.$refs.tour.setTour();
        this.loading_filters = true;
        await this.load();
        await this.load_documents();
        await this.load_customers();
        await this.load_dcs();
        await this.load_cities();
        await this.load_courses();
        await this.load_zones();
        this.loading_filters = false;
        this.filters.show_complete_inputs = true;
        if (this.selected_list.length > 0) this.calcTotalWeight();
	},

	methods: {
        // Carrega a lista de filiais
        load_documents: async function() {
            let res = null;

            try {
                res = await Api.post("delivery/list-my-documents", {
                    start: this.filters.start,
                    end: this.filters.end
                });
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações necessárias de Emissores.");
                return;
            }

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
            
			this.options.documents = this.options_my_documents(res.data);
            return;
		},

        // Carrega a lista de clientes
        load_customers: async function() {
			let res = null;
			try {
				res = await Api.post("delivery/list-my-customers", {
                    start: this.filters.start,
                    end: this.filters.end
                });
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações necessárias de Cliente.");
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
			this.options.customers = this.options_my_customers(res.data);
            return;
		},

        // Obtém a lista de centros
        load_dcs: async function() {
            let res = null;
            
            try {
                res = await Api.post("delivery/list-my-dcs", {
                    start: this.filters.start,
                    end: this.filters.end
                });
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações necessárias dos Centros de Distribuição.");
                return;
            }

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.options.dcs = this.options_my_dcs(res.data);
            return;
        },

        // Carrega a lista de cidades
        load_cities: async function() {
			let res = null;
            
			try {
				res = await Api.post("delivery/list-my-cities", {
                    start: this.filters.start,
                    end: this.filters.end
                });
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações necessárias das Cidades.");
                this.loading = false;
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
            
			this.options.cities = this.options_my_cities(res.data);
			this.options.ufs = this.options_my_ufs(res.data);
            return;
		},
       
        // Carrega a lista de percursos
        load_courses: async function() {
			let res = null;
            
			try {
				res = await Api.post("delivery/list-my-courses", {
                    start: this.filters.start,
                    end: this.filters.end
                });
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações necessárias dos Percursos.");
                this.loading = false;
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
            
			this.options.courses = this.options_my_courses(res.data);
            return;
		},

        // Carrega a lista de cidades
        load_zones: async function() {
			let res = null;
            
			try {
				res = await Api.post("delivery/list-my-zones", {
                    start: this.filters.start,
                    end: this.filters.end
                });
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações necessárias de Zonas.");
                this.loading = false;
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
            
			this.options.zones = this.options_my_zones(res.data);
            return;
		},

        options_my_documents: function(my_documents) {
			let r = {};
			my_documents.map(d => {
				r[d.document] = d.name + " - " + d.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
			});
			return r;
		},
        
        options_my_customers: function(my_customers) {
			let r = {};
			my_customers.map(c => {
				r[c.id] = c.name + " - " + (c.document.length > 11 ? c.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : c.document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
			});
			return r;
		},

        options_my_dcs: function(my_dcs) {
			let r = {};
			my_dcs.map(d => {
                if (d.code) r[d.code] = d.name;
			});
			return r;
		},

        options_my_cities: function(my_cities) {
			let r = {};
            my_cities.map(c => {
                let city = c.city;
                let city_normlized = c.city.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toUpperCase();
                if (typeof r[city_normlized] === "undefined") {
                    r[city_normlized] = city_normlized;
                    this.filters.cities_list[city_normlized] = [city];
                } else {
                    if (!this.filters.cities_list[city_normlized].includes(city)) {
                        this.filters.cities_list[city_normlized].push(city);
                    }
                }
			});
			return r;
		},
        
        options_my_courses: function(my_courses) {
			let r = {};
			my_courses.map(c => {
                r[c.id] = c.code + " - " + c.course;
			});
			return r;
		},
        
        options_my_ufs: function(my_uf) {
			let r = {};
			my_uf.map(z => {
                r[z.uf] = z.uf;
            });
			return r;
		},

        options_my_zones: function(my_zones) {
			let r = {};
			my_zones.map(z => {
                if (z.zone) r[z.postal_code_start + " - " + z.postal_code_end] = z.city + " - " + z.zone + (z.neighborhood != null ? " (" + z.neighborhood + ")" : "");
			});
			return r;
		},

        // Carrega a lista com os registros
        load: async function() {
            let form = {};
            
            this.list = [];
			this.total = 0;

            form.filters = this.filters;
            if (this.filters.city.length > 0) {
                let cities_array = [];
                form.filters.city.forEach(city => {
                    if (typeof this.filters.cities_list[city] !== "undefined") {
                        cities_array = cities_array.concat(this.filters.cities_list[city]);
                    }
                });
                form.filters.cities = cities_array;
            }
            form.order = this.order;
            form.page = this.page;
            form.per_page = this.per_page;
            
            // Requisita as informações
            let result = null;
            this.loading = true;
            try {
                result = await Api.post("delivery/list-delivery", form);
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter a lista de entregas.");
                this.loading = false;
                return;
            }
            this.loading = false;

            // Verifica o resultado
            if (result) {
                // Verifica se ouve erro
                if (result.error) {
                    this.$notification.error(result.data);
                    return;
                }

                // Adiciona o padrão de tempo, ou recupera as alteraçõe já feitas
                result.data.map(r => {
                    // Adiciona alterações gerais
                    let average_discharge_time = r.customer_average_discharge_time ? r.customer_average_discharge_time.split(" ")[0] : 0;
                    let discharge_weight_per_minut = r.discharge_weight_per_minut ? r.discharge_weight_per_minut.split(" ")[0] : 0;

                    r.start_time = this.$parent.data[1].start_time;
                    r.end_time = this.$parent.data[1].end_time;
                    r.customer_average_discharge_time = r.customer_average_discharge_time ? parseInt(average_discharge_time) : this.$parent.data[1].average_discharge_time;
                    r.discharge_weight_per_minut = r.discharge_weight_per_minut ? parseInt(discharge_weight_per_minut) : this.$parent.data[1].discharge_weight_per_minut;
                });

                this.list = result.data;
                this.total = result.total;
                return;
            } else {
                this.$notification.error("Não foi possível obter a lista.");
                return;
            }
        },

        select_document: function() {
			if(this.my_documents.length == 1) {
				this.$refs.company_document_filter.select(this.my_documents[0].document);
			}
		},
        
        // Seleciona os arquivos
        select_files: function() {
            this.$refs.upload_input.click();
		},

        newDelivery: function() {
			this.current_form = "new";
			this.show_modal_form = true;
		},
        
		// Adiciona lista de arquivos
		upload_files: async function() {
			if (Array.isArray(this.$refs.upload_input.files)) {
				this.$refs.upload_input.files.forEach(file => {
					if (this.formats.indexOf(file.type) == -1 ) {
						this.$notification.error("O arquivo " + file.name + " não é de extensão válida (.csv, .xls, .xlsx, .xml ou .txt).");
					} else {
						let find = this.uploading.find(element => element.name == file.name);
						if (typeof find == "undefined") {
							this.uploading.push(file);
						}
					}
				});
			} else {
				Object.keys(this.$refs.upload_input.files).forEach(file => {
					if (this.formats.indexOf(this.$refs.upload_input.files[file].type) == -1 ) {
						this.$notification.error("O arquivo " + this.$refs.upload_input.files[file].name + " não é de extensão válida (.csv, .xls, .xlsx, .xml ou .txt).");
					} else {
						let find = this.uploading.find(element => element.name == this.$refs.upload_input.files[file].name);
						if (typeof find == "undefined") {
							this.uploading.push(this.$refs.upload_input.files[file]);
						}
					}
				});
			}

			if (Object.keys(this.uploading).length == 0) {
				this.$notification.error("Por favor, importe arquivoa válidos (.csv, .xls, .xlsx, .xml ou .txt).");
				return;
			}

			this.show_modal_import = true;
		},

		// Formata o tipo
		toType: function(type) {
			if (type == 0) {
				return "Nota Fiscal";
			} else {
				return "Pedido";
			}
		},

		// Formata a data
		toDate: function(date) {
			let dateAux = date.split("-").reverse().join("/");
			return dateAux;
		},
		
		// Formata o valor em dinheiro
		toMoney: function(money) {
			let moneyAux = money.split(".");
			if(money.length > 1) {
				if (moneyAux[1].length > 1){
					return "R$ " + moneyAux[0] + "," + moneyAux[1];
				} else {
					return "R$ " + moneyAux[0] + "," + moneyAux[1] + "0";    
				}
			} else {
				return "R$ " + moneyAux[0] + ",00";
			}
		},
        
        // Retorna um novo ponto preenchido
        newPoint: function(item) {
            let newPoint = new Object();
            
            newPoint.id = item.id;
            newPoint.document_code = item.document_code;
            newPoint.code_moviment_type = item.code_moviment_type;
            newPoint.document_identifier = item.document_identifier;
            newPoint.document_number = item.document_number;

            newPoint.fk_address = item.fk_address;
            newPoint.postal_code = item.postal_code;
            newPoint.street = item.street;
            newPoint.number = item.number;
            newPoint.complement = item.complement;
            newPoint.neighborhood = item.neighborhood;
            newPoint.city = item.city;
            newPoint.uf = item.uf;
            newPoint.coordinates = item.coordinates;
            newPoint.start_time = item.start_time;
            newPoint.end_time = item.end_time;
            
            newPoint.quantity = item.quantity;
            newPoint.weight = item.weight;

            newPoint.fk_delivery_observation = item.fk_delivery_observation;
            newPoint.observation = item.observation;

            newPoint.is_dc = 0;

            newPoint.fk_customer = item.fk_customer;
            newPoint.customer_name = item.customer_name;
            newPoint.customer_document = item.customer_document;
            newPoint.customer_code = item.customer_code;
            
            newPoint.average_discharge_time = item.customer_average_discharge_time;

            return newPoint;
        },
        
        // Marca/Desmarca todos os registros
        select_all: function() {
            this.list.map(r => {
                let index = this.selected_list.findIndex(element => element.id == r.id);
                if (this.all_selected) {
                    if(index == -1) {
                        if (r.weight) this.total_weight += r.weight;
                        this.selected_list.push(r);
                        this.point_list.push(this.newPoint(r));
                    }
                } else {
                    if(index != -1) {
                        if (r.weight) this.total_weight -= r.weight;
                        this.selected_list.splice(index, 1);
                        this.point_list.splice(index, 1);
                    }
                }
            });
            this.all_selected = !this.all_selected;
        },
        
        // Marca/Desmarca todos os registros selecionados
        selected_select_all: function() {
            this.clean_selected();
        },
        
        // Marca/desmarca ao selecionar um registro individualmente
        on_select: function(item) {
            let index = this.selected_list.findIndex(element => element.id == item.id);
			if(index == -1) {
                if (item.weight) this.total_weight += item.weight;
				this.selected_list.push(item);
                this.point_list.push(this.newPoint(item));
			} else {
                if (item.weight) this.total_weight -= item.weight;
                this.selected_list.splice(index, 1);
                this.point_list.splice(index, 1);
			}
            if (this.selected_list.length == 0) this.all_selected = true;
		},
        
        // Limpa a lista de selecionados
        clean_selected: function() {
            this.point_list.length = 0;
            this.selected_list.length = 0;
            this.total_weight = 0.00;
            this.all_selected = true;
        },
        
        // Valida a lista de registros selecionados
        validation: function() {
            this.loading = true;
            let result = [];
            let error = false;
            
            // Verifica se foi selecionado algum registro
            if(this.selected_list.length > 0) {
                // Verifica se o tamanho é igual a lista dos pontos
                if(this.selected_list.length == this.point_list.length) {
                    result = this.point_list;
                } else {
                    this.$notification.error("Não possível identificar todos os pontos selecionados.");
                    error = true;
                }
            } else {
				this.$notification.error("Selecione ao menos uma entrega.");
                error = true;
            }

            this.loading = false;
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return result;
            }
        },
        
        // Retorna a etapa anterior
        previousStep: function() {
            this.$emit("previous");
        },
        
        // Valida e passa para a próxima etapa
        nextStep: function() {
            let result = this.validation();
            
            if (result != null) {
                this.$emit("next", result);
            }
        },        
        // Cancela o processo atual
        cancel: function () {
            this.$emit("cancel");
        },

        clean_filters: function() {
            this.filters.type = [];
            this.$refs.type_filter.clear_selected();
            this.filters.start = "";
            this.$refs.start_filter.update("");
            this.filters.end = "";
            this.$refs.end_filter.update("");
            
            this.filters.show_complete_inputs = false;

            this.filters.company_document = [];
            this.filters.customer = [];
            this.filters.dc = [];
            this.filters.document_number = "";
            this.filters.postal_code = "";
            this.filters.street = "";
            this.filters.neighborhood = "";
            this.filters.city = [];
            this.filters.uf = [];
            this.filters.zone = [];
            this.filters.course = [];
            this.filters.temperature = [];
            this.filters.bone = [];
            this.filters.no_weight_zero = false;
            
            /*this.$refs.company_document_filter.clear_selected();
            this.$refs.customer_filter.clear_selected();
            this.$refs.dc_filter.clear_selected();
            this.$refs.address_city_filter.clear_selected();
            this.$refs.address_uf_filter.clear_selected();
            this.$refs.address_zone_filter = [];
            this.$refs.address_course_filter = [];
            this.$refs.temperature_filter.clear_selected();
            this.$refs.bone_filter.clear_selected();*/
        },

        filter_deliveries: async function() {
            if ((this.filters.start != "") && (this.filters.end != "")) {
                if ((this.filters.start != this.start_aux) || (this.filters.end != this.end_aux)) {
                    this.filters.show_complete_inputs = false;
                    this.loading_filters = true;
                    await this.load();
                    await this.load_documents();
                    await this.load_customers();
                    await this.load_dcs();
                    await this.load_cities();
                    await this.load_courses();
                    await this.load_zones();
                    this.loading_filters = false;
                    this.filters.show_complete_inputs = true;
                    this.start_aux = this.filters.start;
                    this.end_aux = this.filters.end;
                } else {
                    await this.load();
                    this.filters.show_complete_inputs = true;
                }
            } else {
                if (this.filters.start == "") this.$refs.start_filter.validate();
                if (this.filters.end == "") this.$refs.end_filter.validate();
                this.$notification.error("Por favor, informe a data de entrega inicial e final.");
            }
        },

        updateFiles: function(index) {
			let new_files = [];
			this.uploading.forEach((element, pos) => {
				if (pos != index) new_files.push(element);
			});
			this.uploading = new_files;
		},

        // Reordena a lista
        reorder: function() {
            this.loading = true;
            let order = this.order_selected.split("-");
            this.selected_list.sort(function(a, b) {
                if (order[0] == "id") {
                    if (order[1] == "ASC") {
                        if (a.id  > b.id) return 1;
                        else if (a.id  < b.id) return - 1;
                        else return 0;
                    } else {
                        if (a.id  < b.id) return 1;
                        else if (a.id  > b.id) return - 1;
                        else return 0;
                    }
                } else if (order[0] == "document_number") {
                    if (order[1] == "ASC") {
                        if (a.document_number  > b.document_number) return 1;
                        else if (a.document_number  < b.document_number) return - 1;
                        else return 0;
                    } else {
                        if (a.document_number  < b.document_number) return 1;
                        else if (a.document_number  > b.document_number) return - 1;
                        else return 0;
                    }
                } else if (order[0] == "date") {
                    if (order[1] == "ASC") {
                        if (a.date  > b.date) return 1;
                        else if (a.date  < b.date) return - 1;
                        else return 0;
                    } else {
                        if (a.date  < b.date) return 1;
                        else if (a.date  > b.date) return - 1;
                        else return 0;
                    }
                }
            });
            this.loading = false;
        },

        calcTotalWeight: function() {
            this.selected_list.forEach(element => {
                if (element.weight) this.total_weight += element.weight;
            });
        },
    }
}
</script>

<style scoped>
.container-heading {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.heading-page {
    padding: 7.5px 10px;
}

.btn-delivery {
	float: right;
	border: none;
	background: #d9d9d9;
	color: #000;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
	margin-left: 15px;
}

.add_new_filters {
	float: right;
	border: none;
	background: #222;
	color: #fff;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;	
    margin-top: 25px;
    width: 100%;
}

.container-button-top {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-button-bottom {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #fff;
}

.nf-list {
	position: relative;
	height: 100%;
	overflow: hidden;
}

.nf-list-container {
	float: left;
	width: 100%;
	height: 100%;
	overflow: auto;
	padding-bottom: 15px;
}

.nf-list-item {
	width: 100%;
	float: left;
	background: #eee;
	margin-bottom: 5px;
	padding: 10px;
}

.nf-list-uploading-name {
	float: left;
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 14px;
	font-weight: bold;
}
.nf-list-uploading-status {
	float: left;
	width: 20%;
	font-size: 14px;
	text-align: right;
	color: #999;
}

.nf-list-result-collapse { 
	margin-top: 5px;
	margin-bottom: 5px;
}
.nf-list-result-collapse-header {
	width: 100%;
	padding-top: 5px;
	padding-bottom: 5px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
}
.nf-list-result-collapse-body {
	width: 100%;
	padding-left: 10px;
	white-space: nowrap;
	font-size: 11px;
}

.button-edit {
    padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}

.button-edit-list {
    padding: 5px 15px;
	font-size: 10px;
	font-weight: bold;
    background-color: #222;
    color: #fff;
    border: none;
}

.button-cancel {
    color: #595959;
    background-color: #d9d9d9;
}

.container-collapse-header {
    cursor: pointer;
    padding: 15px;
}

.collapse-body {
    padding: 15px;
    border-top: 1px solid #ddd;
}

.container-filter {
    background-color: #f0f0f0;
}

span.collapse-header-arrow {
    float: right;
}

.config-tab {
	background: #eee;
	border: 1px solid #eee;
	border-bottom: none;
	padding: 10px 15px;
	margin-right: 5px;
	font-weight: bold;
    margin-bottom: -1px;
}

.config-tab.enabled {
	background: #fff;
}

.config-tab-container {
    border-bottom: 1px solid #eee;
}

.config-tab-block {
	display: none;
}
.config-tab-block.show {
	display: block;
}
</style>